<template>
  <div class="create-edit-packing-modal petit-nature-modal">
    <div class="header">
      <h1 class="subtitle is-4" v-if="isCreatePacking">Nova embalagem</h1>
      <h1 class="subtitle is-4" v-else>Editar embalagem</h1>
      <span class="close-button" @click="$emit('close')">
        <i class="mdi mdi-window-close"></i>
      </span>
    </div>
    <form
      action=""
      class="body"
      novalidate
      @submit.prevent="validateBeforeSubmit"
    >
      <div class="columns is-multiline is-variable">
        <div class="column is-8">
          <label class="label">Tamanho</label>
          <b-field expanded>
            <b-input type="number" v-model.trim="$v.packing.size.$model" />
            <p class="control">
              <a class="button is-primary">gramas</a>
            </p>
          </b-field>
        </div>
        <div class="footer column is-12 has-text-right">
          <button
            type="submit"
            class="button is-medium primary"
            :class="{ 'is-loading': isPendingAction }"
            :disabled="isPendingAction"
          >
            <span v-if="isCreatePacking">Adicionar</span>
            <span v-else>Salvar</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapState, mapActions } from "vuex";
import NotificationsWrapper from "../../helpers/NotificationsWrapper";
export default {
  name: "CreateEditPackingModal",
  data: () => ({
    isCreatePacking: true,
    isPendingAction: false,
    packing: {}
  }),
  computed: {
    ...mapState({})
  },
  methods: {
    ...mapActions({
      createPacking: "packing/createPacking",
      editPacking: "packing/editPacking"
    }),
    validateBeforeSubmit() {
      this.$v.packing.$touch();
      if (this.$v.packing.$invalid) {
        return;
      }
      if (this.isCreatePacking) {
        this.createPacking(this.packing)
          .then(() => {
            NotificationsWrapper.success("Embalagem cadastrada com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar a embalagem. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      } else {
        this.editPacking(this.packing)
          .then(() => {
            NotificationsWrapper.success("Embalagem atualizada com sucesso!");
            this.$emit("close");
          })
          .catch(error => {
            let errorCode = { error }.error.response.status;

            switch (errorCode) {
              default:
                NotificationsWrapper.error(
                  "Não foi possível atualizar a embalagem. Tente novamente."
                );
                break;
            }
          })
          .finally(() => (this.isPendingAction = false));
      }
    }
  },
  validations: {
    packing: {
      size: { required }
    }
  },
  props: {
    packingParam: {}
  },
  created() {
    if (!this.packingParam.id) {
      this.isCreatePacking = true;
      this.packing = { size: 0 };
    } else {
      this.packing = this.packingParam;
      this.isCreatePacking = false;
    }
  }
};
</script>

<style scoped></style>
